import { FilterByMaker } from '@root/features/trade/filters'

import type { PairHoldersTableColumnId } from '../atoms/reatom-pair-holders-column-id'
import type { ClassNameProps } from '@root/shared/react'
import type { TableFilter } from '@root/shared/ui-kit/data-table/atoms/table-filter'

type HolderTableBalCellProps = {
  filter: TableFilter<string> | undefined
  setColumnFilter: (filter: TableFilter<PairHoldersTableColumnId>) => void
  clearColumnFilter: () => void
  columnId: PairHoldersTableColumnId
} & ClassNameProps

export const HolderTableMakerHeader = (props: HolderTableBalCellProps) => {
  return <FilterByMaker {...props} />
}
